import { Routes } from '@angular/router';
import { PageKey } from '../../../../shared/services/page/models/page.key';

export const departmentsRoute: Routes = [{
  path: 'departments',
  loadComponent: () => import('./departments.component').then(m => m.DepartmentsComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./list/list.component').then(m => m.ListDepartmentsComponent),
      data: {
        title: 'Listar Departamentos',
        key: PageKey.USERS,
        fullscreen: true
      },
    },
    {
      path: 'list',
      loadComponent: () => import('./list/list.component').then(m => m.ListDepartmentsComponent),
      data: {
        title: 'Listar Departamentos',
        key: PageKey.USERS,
        fullscreen: true
      },
    },
    {  
      path: 'create', 
      loadComponent: () => import('./create/create.component').then(m => m.CreateDepartmentComponent),
      data: {
        title: 'Criar Departamento',
        key: PageKey.USERS,
        fullscreen: true
      }
    },
    {
      path: ':id/update',
      loadComponent: () => import('./create/create.component').then(m => m.CreateDepartmentComponent),
      data:{
        title: 'Editar Departamento',
        key: PageKey.USERS,
        fullscreen: true
      }
    }
  ]
}];
